import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private ProcurementPosition Types */
import {
  Settings,
  _ProcurementPosition
} from '../namespace-helper'

import _ from 'lodash'

const initSelectedProcurementPosition = {
  id: 0,
  purchase_orders_id: 0,
  purchase_orders_positions_status_id: 0,
  customers_offers_position_id: 0,
  suppliers_offers_positions_id: '',
  delivery_times_id: 0,
  products_id: 0,
  vats_id: 0,
  quantity: null,
  unit_purchase_price: null,
  unit_sales_price: null,
  total_sales_price: null,
  description: null,
  remark: null,
  customers_offers_position: {
    description: null,
    customers_offer: {
      currency: {
        name: null,
        id: 0
      },
      customer: {},
      message: {
        attachments: [
          {
            documents_id: 0
          }
        ]
      }
    },
    delivery_time: {}
  },
  product: {
    manufacturer: {
      name: null
    },
    product_description: {
      description: null
    }
  },
  supplier_offers_position: {
    suppliers_offer: {
      supplier: {},
      currency: {}
    },
    delivery_time: {},
    discounts: []
  },
  unit: {
    code: ''
  },
  purchase_orders_position: {
    purchase_order: {
      currency: {
        name: null
      }
    },
    product: {
      manufacturer: {
      },
      product_description: {
      }
    },
    unit: {
    }

  }
}

export default {
  namespaced: true,
  state: {
    procurementPositions: [],
    selectedProcurementPosition: _.cloneDeep(initSelectedProcurementPosition),
    openDialog: false
  },
  mutations: {
    [_ProcurementPosition.mutations.setProcurementPositions] (state, payload) {
      state.procurementPositions = payload
    },
    [_ProcurementPosition.mutations.setSelectedProcurementPosition] (state, payload) {
      if (payload !== null) {
        state.selectedProcurementPosition = payload
      } else {
        state.selectedProcurementPosition = _.cloneDeep(initSelectedProcurementPosition)
      }
    },
    [_ProcurementPosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_ProcurementPosition.actions.saveProcurementPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/procurementPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_ProcurementPosition.mutations.setSelectedProcurementPosition, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/procurementPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_ProcurementPosition.mutations.setSelectedProcurementPosition, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_ProcurementPosition.actions.confirmProcurementPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)
      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/procurementPositions/' + payload.id + '/confirmProcurementPosition'

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProcurementPosition.actions.loadProcurementPositions] (context, payload) {
      console.log('loadProcurementPositions: ' + JSON.stringify(payload))
      console.log('loadProcurementPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/procurementPositions/procurement/' + payload.id + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;purchase_orders_number:like;customer.name:like;account.firstname:like;purchaseOrdersStatus.name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOrders: ' + JSON.stringify(r.data.data))
        context.commit(_ProcurementPosition.mutations.setProcurementPositions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ProcurementPosition.actions.openCloseDialog] ({ commit }) {
      commit(_ProcurementPosition.mutations.setOpenCloseDialogState)
    },
    [_ProcurementPosition.actions.setSelectedProcurementPosition] ({ commit }, payload) {
      commit(_ProcurementPosition.mutations.setSelectedProcurementPosition, payload)
    },
    [_ProcurementPosition.actions.reloadSelectedProcurementPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/procurementPositions/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_ProcurementPosition.mutations.setSelectedProcurementPosition, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProcurementPosition.actions.resetState] ({ commit }, payload) {
      commit(_ProcurementPosition.mutations.setProcurementPositions, [])
      commit(_ProcurementPosition.mutations.setSelectedProcurementPosition, null)
    }
  },
  getters: {
    [_ProcurementPosition.getters.procurementPositions] (state) {
      return state.procurementPositions
    },
    [_ProcurementPosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_ProcurementPosition.getters.getSelectedProcurementPosition] (state) {
      return state.selectedProcurementPosition
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ProcurementPositions/procurementPositions.js